import { render, staticRenderFns } from "./CreateAddon.vue?vue&type=template&id=58696945&scoped=true&"
import script from "./CreateAddon.vue?vue&type=script&lang=js&"
export * from "./CreateAddon.vue?vue&type=script&lang=js&"
import style0 from "./CreateAddon.vue?vue&type=style&index=0&id=58696945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58696945",
  null
  
)

export default component.exports